const initialState = {
    responseAlert: [],
    errorAlert: false,

    listResponselerts: [],
    errorListAlerts: false,

    createResponselerts: [],
    errorcreateAlerts: false,

    alertEditResponse: [],
    alertEditResponsError: false,

    alertDeleteResponse: [],
    alertDeleteResponseError: false,
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "ALERT_RESPONSE":
            newState.responseAlert = action.value;
            if (action.value === undefined) {
                newState.errorAlert = true;
            } else {
                newState.errorAlert = false;
            }
            break;

        case "GET_ALERTS_LIST":
            newState.listResponselerts = action.value;
            if (action.value === undefined) {
                newState.errorListAlerts = true;
            } else {
                newState.errorListAlerts = false;
            }
            break;

        case "EDIT_ALERT_RESPONSE":
            newState.alertEditResponse = action.value;
            console.log('%c alertEditRespons / action.value :', 'color: #b37900; background: #fff7e6', action.value);
            console.log('%c alertEditRespons / action.value :', 'color: #b37900; background: #fff7e6', action.value.id === undefined);
            if (action.value.id === undefined) {
                newState.alertEditResponsError = true;
            } else {
                newState.alertEditResponsError = false;
            }
            break;

        case "DELETE_ALERT_RESPONSE":
            newState.alertDeleteResponse = action.value;
            if (action.value === undefined) {
                newState.alertDeleteResponseError = true;
            } else {
                newState.alertDeleteResponseError = false;
            }
            break;

        case "CREATE_ALERT_RESPONSE":
            newState.createResponselerts = action.value;

            if (action.value === undefined) {
                newState.errorcreateAlerts = true;
            } else {
                newState.errorcreateAlerts = false;
            }
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;